import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

import { Hide } from '#/components/Hide/Hide';
import { breakpointValues } from '#/theme/theme';

import { ClientOnly } from './ClientOnly';

const breakpointNames = ['xs', 'sm', 'md', 'lg', 'xl'] as const;

export function HideContainer({
  children,
  xs = false,
  sm = false,
  md = false,
  lg = false,
  xl = false,
  mobile = false,
  desktop = false,
  noWrapper = false,
  ...props
}: {
  children: ReactNode;
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  mobile?: boolean;
  desktop?: boolean;
  noWrapper?: boolean;
}) {
  const [breakpoint, setBreakpoint] = useState(0);

  const hide = {
    xs: xs || mobile,
    sm: sm || mobile,
    md: md || mobile,
    lg: lg || desktop,
    xl: xl || desktop,
  };

  const resizeHandler = () => {
    const width = window.innerWidth;
    const newBreakpoint = [
      breakpointValues.xs,
      breakpointValues.sm,
      breakpointValues.md,
      breakpointValues.lg,
    ].reduce(
      (current, point, index) => (width >= point ? index + 1 : current),
      0,
    );
    setBreakpoint(newBreakpoint);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      resizeHandler();
      window.addEventListener('resize', resizeHandler);

      return () => {
        window.removeEventListener('resize', resizeHandler);
      };
    }
  }, []);

  if (noWrapper) {
    if (hide[breakpointNames[breakpoint]]) return null;
    return <ClientOnly>{children}</ClientOnly>;
  }

  return (
    <Hide
      xs={hide.xs}
      sm={hide.sm}
      md={hide.md}
      lg={hide.lg}
      xl={hide.xl}
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </Hide>
  );
}
